import React, { Component } from "react";
import logo from "../../../../../../../../assets/web/images/logo/mesa_de_regalos_logo.svg"; // sample logo
import headerBg from "../../../../../../../../assets/web/images/pattern/Elegancia_black.png"; // sample background image
import commonUtil from "../../../../../../../utils/commonUtil";

class MessagesTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      printingDate,
      allMessages,
      eventID,
      eventInfo: { eventName, eventDate, eventId } = {},
      lables,
    } = this.props;

    const messages = [
      {
        guestName: "Lucía Miranda",
        repliedMessage: `No saben la emoción que me da acompañarlos en este momento tan importante. 
Sé que será una celebración hermosa y llena de amor, tal como lo que han construido juntos.
¡Ya quiero verlos decir "sí"!`,
      },
      {
        guestName: "Jorge Álvarez",
        repliedMessage: `Falta poco para ese gran día y no puedo estar más feliz por ustedes.
Lo que están por comenzar es una aventura maravillosa y estoy agradecido de poder ser testigo de ello.`,
      },
      {
        guestName: "Renata Villaseñor",
        repliedMessage: `Desde que recibí la invitación, no he dejado de sonreír.`,
      },
      {
        guestName: "Iván Delgado",
        repliedMessage: `¡Ya quiero que llegue el gran día!
Sé que la boda será hermosa, pero lo más bonito es ver cómo se acompañan con tanto cariño y respeto.
Gracias por compartir su alegría con todos nosotros.`,
      },
      {
        guestName: "Santiago Meza",
        repliedMessage: `¡Qué emoción! En unos días estarán celebrando el amor de una vida entera.
Estoy feliz por ustedes y por lo que están por construir juntos.`,
      },
      {
        guestName: "Ana Laura Ríos",
        repliedMessage: `La cuenta regresiva ha comenzado y me emociona muchísimo pensar en todo lo que van a vivir.
Se nota que están hechos el uno para el otro, y celebrar su unión será un privilegio.
¡Nos vemos pronto con mucha alegría!`,
      },
    ];

    let formattedDate = "";
    if (eventDate && typeof eventDate === "string" && eventDate.includes("-")) {
      const [year, month, day] = eventDate.split("-");
      if (year && month && day) {
        formattedDate = `${day}/${month}/${year}`;
      }
    }

    return (
      <div id="messages-template-pdf" className="messages-template-mtp">
        {/* <div
          className="header-mtp"
          style={{ backgroundImage: `url(${headerBg})` }}
        >
          <img src={logo} alt="Liverpool Logo" className="header-logo-mtp" />
        </div> */}

        <div className="event-title-mtp">
          {eventName ? eventName : "Boda en leon"}
        </div>
        <div className={`event-meta-mtp ${allMessages && allMessages.length == 1 && 'event-meta-mtp-single'}`}>
          <div className={`event-date-mtp ${allMessages && allMessages.length == 1 && 'event-date-mtp-single'}`}>
            <span className="icon-mtp">
              <img
                src={commonUtil.getAssetURL() + "/images/event_black.svg"}
                alt="event_icon"
              />
            </span>
            {formattedDate}
          </div>
          <div className={`event-id-mtp ${allMessages && allMessages.length == 1 && 'event-id-mtp-single'}`}>
          <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.nombreEvent.label')}</span>: {eventId ? eventId : eventID || "00000000"}
          </div>
        </div>

        <div className="messages-section-mtp">
          {
          allMessages
           .filter((msg) => msg.customMessage && msg.customMessage.trim() !== "")
          .map((msg, index) => (
            <div className="message-block-mtp" key={index}>
              <div className={`message-from-mtp ${allMessages && allMessages.length == 1 && 'message-font-single'}`}>
                <span className="label-mtp">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosrecibidos.of.pdf.label')} </span>
                <span className="value-mtp">{msg.guestName}</span>
              </div>
              <div className="message-body-mtp">
                <div className={`label-mtp ${allMessages && allMessages.length == 1 && 'message-font-single'}`}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosrecibidos.message.pdf.label')}</div>
                <div className="value-mtp">{msg?.customMessage
                    ? msg.customMessage
                    : commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.deafult.message"
                    )}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default MessagesTemplate;
